import React from "react";
import "@assets/css/SplashLoader.css";
const SplashLoader = () => {
  return (
    <div className="h-screen flex items-center justify-center bg-white">
      <div className="mask">
        <div className="loader">
          <div className="loader__bounce first"></div>
          <div className="loader__bounce second"></div>
          <div className="loader__bounce third"></div>
        </div>
      </div>
    </div>
  );
};

export default SplashLoader;
